import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'gb-check-in-instructions',
  templateUrl: './gb-check-in-instructions.component.html',
  styleUrls: ['./gb-check-in-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbCheckInInstructionsComponent {
  @Input() primaryColor = 'var(--gb-primary-color-500)'
  @Input() backgroundColor = 'var(--gb-primary-color-900)'
  @Input() qrCodeColor = 'var(--gb-primary-color-500-contrast)'
  @Input() numberColor = 'var(--gb-primary-color-500-contrast)'
  @Input() successColor = '#49a167'

  getStyle(color: string) {
    return {
      fill: color,
    }
  }
}
